var map = {
	"./board-game.png": 3842,
	"./chat.svg": 8701,
	"./chess.svg": 2569,
	"./church.png": 5716,
	"./class.svg": 5257,
	"./dance.svg": 6891,
	"./dice.png": 5684,
	"./earth.png": 9709,
	"./football.png": 5910,
	"./gymnastic.svg": 7914,
	"./ice-skate.svg": 9673,
	"./language.svg": 8997,
	"./swimmer.png": 6753,
	"./user-talking.png": 3377,
	"./voice.png": 2547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;